import type { Framework } from '@toeverything/infra';

import { ContainerCopyBeforeDeleteService } from '../../components/delete-with-copy/container-copy-before-delete.service';
import { SettingsMemory } from '../../desktop/dialogs/setting/settings-memory';
import { SettingsNavigationOwner } from '../../desktop/dialogs/setting/settings-navigation-owner';
import { WorkspaceServerService } from '../cloud';
import { OfflineMutationOutboxService } from '../offline-mutation-outbox/services/offline-mutation-outbox';
import { AccessibleFolderCacheStore } from '../organize/stores/accessible-folder-cache';
import { WorkspacePermissionService } from '../permissions/services/permission';
import { GlobalState } from '../storage/providers/global';
import { WorkspaceViewContextService } from '../streamlain/copilot/workspace-view-context';
import { WorkspaceScope } from '../workspace';
import { WorkspaceService } from '../workspace/services/workspace';
import { GlobalDialogService } from './services/dialog';
import { WorkspaceDialogService } from './services/workspace-dialog';

export type { GLOBAL_DIALOG_SCHEMA, WORKSPACE_DIALOG_SCHEMA } from './constant';
export { GlobalDialogService } from './services/dialog';
export { WorkspaceDialogService } from './services/workspace-dialog';
export type { DialogComponentProps } from './types';

export function configureDialogModule(framework: Framework) {
  framework
    .service(GlobalDialogService)
    .service(SettingsMemory, [GlobalState])
    .scope(WorkspaceScope)
    .service(WorkspaceDialogService)
    .service(ContainerCopyBeforeDeleteService, [
      WorkspaceServerService,
      WorkspaceDialogService,
      WorkspacePermissionService,
      WorkspaceService,
      OfflineMutationOutboxService,
      AccessibleFolderCacheStore,
    ])
    .service(SettingsNavigationOwner, [
      WorkspaceDialogService,
      WorkspaceViewContextService,
      SettingsMemory,
    ]);
}
